import React, { Component } from 'react';
import { Row, Col, InputGroup, Input, FormFeedback, Button, Label, Container } from 'reactstrap';
import CustomLabel from '../CustomLabel';
import { Typeahead } from 'react-bootstrap-typeahead';
import { UncontrolledTooltip } from 'reactstrap';
import { colorTheme } from '../../utils/constants';
import { IonIcon } from '@ionic/react';
import { addOutline, trashOutline } from 'ionicons/icons';

class OtherRecurringBills extends Component {
    state = {
      isTableExpanded: false,
    };

    handleToggleTable = () => {
      this.setState((prevState) => ({
        isTableExpanded: !prevState.isTableExpanded,
      }));
    };
    render() {
      const { otherRecurringBillsItems, handleChangeBillsOptions, handleChangeBillsAmount, errors, onClickAddItem, onClickDeleteItem, otherRecurringBillsItemOptions, propsItems, options, form, name , propertyBills, unitBills} = this.props;
      const propertyTooltipText="Just like rent, these are additional bills that need to be charged on a monthly basis. These bills have a fixed amount"
      const unitTooltipText="Add or edit bills to be charged monthly for this specific unit"
      const { isTableExpanded } = this.state;
      return (
        <>
        {form == 'unit' && propertyBills && propertyBills.length > 0 && (
          <Row>
            <Col sm={12} md={4}></Col>
            <Col>
              <h6>
                <span style={{ color: 'black' }}>( </span>
                <span className='text-warning'>
                  Recurring bills for all units in this property are: {propertyBills.map((item, index) => (
                    <span key={index}>
                      {`${item.bill}: ${item.amount}${index !== propertyBills.length - 1 ? ', ' : ''}`}
                    </span>
                  ))}
                </span>
                <span> )</span>
              </h6>
            </Col>
          </Row>
        )}

        <Row>
          <CustomLabel sm={12} md={4} for="otherRecurringBills">
            {/* Adjusting label column width based on the 'form' type */}
            Other Recurring Bills <br/> (optional)
            <i id="otherRecurringBills" placement="top" className="fa fa-fw fa-info-circle ml-1 mt-1"></i>
            <UncontrolledTooltip target="otherRecurringBills">
            {form === "unit"? unitTooltipText : propertyTooltipText}
            </UncontrolledTooltip>
          </CustomLabel>

          <Col style={{ maxWidth: '450px' }} sm={12} md={7}>
            {/* Adjusting label column width based on the 'form' type */}
            {otherRecurringBillsItems.map((item, index) => (
              <Row id={index.toString()} className="mb-4" key={index.toString()}>
                <Col>
                  <Row>
                    <Col className="my-1" style={{ minWidth: '200px' }} id={`otherRecurringBillsContainer${index}`}>
                      <Typeahead
                        clearButton
                        id={`otherRecurringBillsItem${index.toString()}`}
                        options={otherRecurringBillsItemOptions || []}
                        name="otherRecurringBillsItem"
                        placeholder="Select bill type"
                        selected={item.bill}
                        onChange={(selected) => handleChangeBillsOptions(index, selected, propsItems, options)}
                      />
                      {(errors[index] && errors[index].bill.length > 0) && (
                        <p className="text-danger">{errors[index].bill}</p>
                      )}
                    </Col>

                    <Col className="my-1" style={{ minWidth: '200px' }}>
                      <InputGroup>
                        <Input
                          id={`amount${index.toString()}`}
                          name="amount"
                          placeholder="amount"
                          value={item.amount}
                          onChange={(event) => handleChangeBillsAmount(index, event)}
                          invalid={errors[index] && errors[index].amount.length > 0 }
                        />
                        <FormFeedback>{errors[index] ? errors[index].amount : ""}</FormFeedback>
                      </InputGroup>
                    </Col>
                    {form == "unit" && name && item.bill.length>0 && (<p className='ml-3'>This will override the property level pricing for {item.bill[0].label || item.bill[0]} for {name}. <small>(Please set the amount to zero if you wish to exclude the selected unit from {item.bill[0].label || item.bill[0]} charge.)</small></p>)}
                    {form === 'property' && unitBills && unitBills.length > 0 && (
                      <Row>
                        {unitBills.filter(unit => unit.bill.indexOf(item.bill[0]?.label) !== -1 && unit.amount[unit.bill.indexOf(item.bill[0]?.label)] !== item.amount).length > 0 && (
                        <small className="ml-4 text-warning">
                          This {item.bill[0]?.label} bill amount will be exempted for these units: {unitBills.filter(unit => unit.bill.indexOf(item.bill[0]?.label) !== -1 && unit.amount[unit.bill.indexOf(item.bill[0]?.label)] !== item.amount).map(unit => unit.name).join(", ")} &nbsp;
                          <small style={{color: colorTheme["primary"]["700"]}} onClick={this.handleToggleTable}>
                            {isTableExpanded ? <i className="fa fa-minus"></i> : <span>Learn more... <i className="fa fa-chevron-down"></i></span>}
                          </small>
                        </small>
                      )}
                      {isTableExpanded && unitBills.filter(unit => unit.bill.indexOf(item.bill[0]?.label) !== -1 && unit.amount[unit.bill.indexOf(item.bill[0]?.label)] !== item.amount).length > 0 && (
                        <table className="table">
                          <thead>
                          <tr className='ml-2'>
                            <td colSpan="3">
                              These bills are set at the unit level. You can go to the unit form to make changes for specific units or remove them.
                            </td>
                          </tr>
                            <tr>
                              <th>Unit</th>
                              <th>Bill</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                          {unitBills.filter(unit => unit.bill.indexOf(item.bill[0]?.label) !== -1 && unit.amount[unit.bill.indexOf(item.bill[0]?.label)] !== item.amount).map((unit, index) => (
                            <tr key={index}>
                              <td>{unit.name}</td>
                              <td>{unit.bill[unit.bill.indexOf(item.bill[0]?.label)]}</td>
                              <td>{unit.amount[unit.bill.indexOf(item.bill[0]?.label)]}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      )}
                    </Row>
                    )}
                  </Row>
                </Col>

                {otherRecurringBillsItems.length - 1 === index && (
                  <Col className="d-flex align-items-end mt-1 mx-1 mr-2" style={{ maxWidth: '50px' }}>
                    <Button id={`otherRecurringBillsAddButton${index}`} outline color="secondary" onClick={onClickAddItem}>
                      <IonIcon icon={addOutline} className="mr-1" />
                    </Button>
                  </Col>
                )}

                {otherRecurringBillsItems.length > 1 && (
                  <Col className="d-flex align-items-end mt-1 mx-1 mr-2" style={{ maxWidth: '50px' }}>
                    <Button id={`otherRecurringBillsDeleteButton${index}`} outline color="secondary" onClick={() => onClickDeleteItem(index)}>
                      <IonIcon icon={trashOutline} />
                    </Button>
                  </Col>
                )}
              </Row>
            ))}
          </Col>
        </Row>
        </>
      );
    }
  }

  export default OtherRecurringBills;